var _defs, _rect, _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2d2d87;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: #f4eb34;\n      }\n\n      .st6, .st5 {\n        fill: #2e6934;\n      }\n\n      .st2, .st7 {\n        fill: #e81e26;\n      }\n\n      .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        fill: #000101;\n      }\n\n      .st8 {\n        fill: #b5202e;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 0,
    width: 21,
    height: 15,
    rx: 3.1,
    ry: 3.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3.1 15 7.3 15 7.3 0 3.1 0 3.1 15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 7.3,
    width: 13.7,
    height: 15,
    rx: 3.1,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.3 15 16.1 15 16.1 0 7.3 0 7.3 15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 0,
    width: 7.3,
    height: 15,
    rx: 3.1,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,9.8c-.9,0-5.2-3.3-5.2-3.8l.2-.5c.4.8,4.8,3.9,5.2,3.8l-.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,9.8s0,0-.1,0c-.3,0-1.4-.7-2.6-1.6-1.4-1.1-2.6-2-2.5-2.3h0c0,0,0,0,0,0-.1.4,2.4,2.2,2.5,2.3,1.4,1.1,2.6,1.7,2.7,1.6h0ZM4.7,5.5c0,.3,1.1,1.2,2.5,2.2,1.4,1.1,2.7,1.7,2.8,1.6,0,0,0,0,0,0,0,0,0,0-.1,0-.4-.1-1.4-.7-2.6-1.6-1.2-.9-2.3-1.8-2.5-2.1,0,0,0,0,0-.1h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10,9.4c-.2,0-1.4-.6-2.7-1.6-1.5-1.1-2.6-2-2.5-2.3h0c0,0,0,0,0,0h0c0,.4,1.3,1.4,2.5,2.3,1.3,1,2.5,1.6,2.7,1.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0-.1,0-.4-.1-1.5-.8-2.6-1.6-1.1-.8-2.3-1.8-2.5-2.2,0,0,0,0,0-.1,0,0,0,0,0,.1.2.4,1.4,1.3,2.5,2.1,1.2.9,2.2,1.5,2.6,1.6,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM9.7,9.9s0,0,0,0c-.4,0-1.4-.7-2.6-1.6-1.6-1.2-2.5-1.9-2.5-2.2,0,0,0,0,0,0h0c0,0,0,0,0,0h0c0,0,0,.1,0,.1,0,.3.9,1,2.5,2.2,1.2.9,2.3,1.5,2.6,1.6,0,0,0,0,0,0h0s0,0,0,0c-.3,0-1.4-.6-2.7-1.6,0,0,0,0,0,0-1.6-1.2-2.4-1.9-2.4-2.2,0,.2.4.7,2.4,2.2,0,0,0,0,0,0,1.3,1,2.4,1.6,2.7,1.6s0,0,0,0h0s0,0,0,0h0c0,.1,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,6.3c.9,0,2.1-.2,2.7-.5v-.3c-.5.3-1.7.4-2.7.5-1.2,0-2.1-.2-2.6-.5v.3c.7.4,1.5.5,2.6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,5.6c0,0-.4.2-1,.3-.4,0-.9.1-1.6.1-.6,0-1.2,0-1.5-.1-.6,0-1-.3-1.1-.3,0,0,0,0,0,0,0,0,.4.2,1,.3.4,0,.9.1,1.5.1s1.2,0,1.6-.1c.6-.1,1-.3,1-.3h0ZM10.1,5.9s-.5.2-1.1.4c-.4,0-1,.1-1.7.1s-1.2,0-1.6-.1c-.7-.1-1-.3-1.1-.4,0,0,0,0,0,0,.4.2.7.3,1.1.4.4,0,.9.1,1.6.1.7,0,1.2,0,1.7-.2.6-.1,1-.3,1.1-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.8,5.5h0c0,0,0,0,0,0,.2,0,.5.2,1,.3.4,0,1,.1,1.5.1h0s0,0,0,0c.6,0,1.1,0,1.6-.1.6-.1,1-.3,1-.3h0s-.4.2-1,.3c-.5,0-1,.1-1.6.1s-1.2,0-1.5-.1c-.7-.1-1-.3-1.1-.3h0ZM7.3,6.1c-.6,0-1.1,0-1.5-.1-.6,0-.9-.2-1-.3h0s0,0,0,0c0,0,0,0,0,0,0,0,.4.2,1,.3.3,0,.8.1,1.5.1s1.1,0,1.6-.1c.6,0,.9-.3,1-.3h0c0,.2-.4.3-1,.5-.5,0-1,.1-1.6.1h0ZM4.6,5.8h0c.1.1.5.3,1.1.4.5,0,1,.1,1.6.1h0s0,0,0,0c.6,0,1.2,0,1.7-.1.6-.1,1.1-.3,1.1-.4h0s-.4.2-1,.3c-.6.1-1.1.2-1.7.2-.6,0-1.1,0-1.6-.1-.4,0-.8-.2-1.1-.4h0ZM7.3,6.4c-.6,0-1.1,0-1.6-.1-.6-.1-1-.3-1.1-.4h0s0,0,0,0c.4.2.7.3,1.1.4.5,0,1,.1,1.6.1.6,0,1.1,0,1.7-.2.6-.1,1-.3,1-.4h0c0,.2-.5.3-1.1.5-.5,0-1.1.1-1.7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,7.7c.6.4,1.8.6,3,.6,1.1,0,2.5-.2,3-.6v-.4c-.2.3-1.7.6-3.1.6-1.3,0-2.6-.3-3-.6v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.4,7.3h0c0,.2-.6.4-1.2.5-.5,0-1.1.2-1.9.2s-1.3,0-1.8-.2c-.7-.1-1.2-.4-1.3-.4h0c.3.1,1,.3,1.3.3.5,0,1,.1,1.8.1s1.4,0,1.9-.2c.5,0,1.1-.3,1.2-.4h0ZM10.4,7.7h0c0,.2-.6.4-1.2.5-.5,0-1.1.2-1.9.2s-1.3,0-1.8-.1c-.7-.1-1.2-.4-1.3-.4h0c.3.1,1,.3,1.3.3.5,0,1,.1,1.8.1s1.4,0,1.9-.2c.4,0,1.1-.3,1.2-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.3,7.3h0c0,.1.5.4,1.3.5.5,0,1.1.2,1.8.2s1.3,0,1.9-.2c.6-.1,1.1-.3,1.2-.4h0c-.1,0-.8.3-1.2.4-.6.1-1.2.2-1.9.2s-1.2,0-1.8-.1c-.3,0-1-.2-1.3-.4h0ZM7.3,8c-.7,0-1.3,0-1.8-.2-.7-.1-1.2-.3-1.3-.4h0c.3.1,1.1.3,1.3.3.5,0,1.1.1,1.8.1s1.3,0,1.9-.2c.4,0,1.1-.3,1.2-.4h0c0,.2-.6.4-1.2.5-.6.1-1.2.2-1.9.2h0ZM4.3,7.7h0c0,.1.5.4,1.3.5.5,0,1.1.1,1.8.1s1.3,0,1.9-.2c.6-.1,1.1-.3,1.2-.4h0c-.1,0-.8.3-1.2.4-.6.1-1.2.2-1.9.2s-1.2,0-1.8-.1c-.3,0-1-.2-1.3-.4h0ZM7.3,8.3c-.7,0-1.3,0-1.8-.2-.7-.1-1.2-.3-1.3-.4h0c.3.1,1.1.3,1.3.3.5,0,1.1.1,1.8.1s1.3,0,1.9-.2c.4,0,1.1-.3,1.2-.4h0c0,.2-.6.4-1.2.5-.6.1-1.2.2-1.9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,9.8c-1.3,0-2.4-.4-2.7-.5l.2.3c.4.2,1.5.5,2.5.5,1,0,1.9-.1,2.5-.5l.2-.3c-.4.2-1.8.5-2.7.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,9.2s0,0,0,0c0,0,0,0,0,.1-.2,0-.6.2-1.2.3-.4,0-.7.1-1.5.2-1.5,0-2.5-.4-2.7-.5h0c.9.2,1.8.4,2.7.4.7,0,1,0,1.4-.2.7-.1,1.1-.3,1.2-.3,0,0,0,0,0,0h0ZM9.9,9.5s0,0,0,.1c-.3.1-.7.3-.9.3-.4,0-1,.2-1.5.2-1.2,0-2.1-.3-2.6-.5h0c0,0,0,0,0,0h0c.8.4,1.7.5,2.5.5.5,0,1.1,0,1.5-.2.7-.2.9-.3,1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.4,9.8h0c-1.3,0-2.3-.3-2.7-.5h0c1,.2,1.9.4,2.7.4.7,0,1,0,1.3-.1h.1c.7-.2,1-.3,1.2-.3h0s0,0,0,0h0c-.1.1-.5.2-1.2.4h-.1c-.3,0-.7.1-1.3.2-.9,0-1.7-.2-2.7-.5h0c.4.2,1.4.5,2.7.6.7,0,1,0,1.3-.1h.2c.5-.1,1-.3,1.2-.3h0c0-.1,0,0,0,0-.2,0-.6.2-1.2.3h-.2c-.3,0-.6.1-1.3.2h0ZM4.8,9.5h0c.5.3,1.4.6,2.5.6.5,0,1.1,0,1.5-.2.2,0,.7-.2.9-.3,0,0,0,0,0-.1,0,0-.3.2-1,.3-.4,0-.9.2-1.5.2h0c-1,0-1.8-.2-2.6-.5h0ZM7.3,10.1h0c-1.2,0-2.1-.3-2.6-.5h0c0,0,0-.1,0-.1h0c.7.3,1.6.5,2.5.5h0c.6,0,1.2,0,1.5-.2.7-.2,1-.3,1-.3,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,.1-.3.1-.7.3-.9.3-.4.1-1,.2-1.5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,3.8c1.6,0,3,1.6,3,3.7s-1.3,3.7-3,3.7-3-1.6-3-3.7,1.3-3.7,3-3.7h0ZM7.3,4.2c1.5,0,2.7,1.5,2.7,3.3s-1.2,3.3-2.7,3.3-2.7-1.5-2.7-3.3c0-1.8,1.2-3.3,2.7-3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,3.9c1.6,0,3,1.6,3,3.6s-1.3,3.6-3,3.6-3-1.6-3-3.6c0-2,1.3-3.6,3-3.6h0ZM7.3,3.8c1.7,0,3,1.7,3,3.7s-1.4,3.7-3,3.7-3-1.7-3-3.7,1.4-3.7,3-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,3.9c-1.6,0-3,1.6-3,3.6s1.3,3.6,3,3.6,3-1.6,3-3.6-1.3-3.6-3-3.6h0ZM7.3,11.1c-1.6,0-3-1.6-3-3.6s1.3-3.6,3-3.6,3,1.6,3,3.6-1.3,3.6-3,3.6h0ZM7.3,3.8c-1.7,0-3,1.7-3,3.7s1.4,3.7,3,3.7,3-1.7,3-3.7-1.4-3.7-3-3.7h0ZM7.3,11.2c-1.7,0-3-1.7-3-3.7s1.4-3.7,3-3.7,3,1.7,3,3.7-1.4,3.7-3,3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,4.2c1.5,0,2.7,1.5,2.7,3.3s-1.2,3.3-2.7,3.3-2.7-1.5-2.7-3.3c0-1.8,1.2-3.3,2.7-3.3h0ZM7.3,4.1c1.5,0,2.8,1.5,2.8,3.4s-1.3,3.4-2.8,3.4c-1.5,0-2.8-1.5-2.8-3.4,0-1.9,1.3-3.4,2.8-3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,4.2c-1.5,0-2.7,1.5-2.7,3.3s1.2,3.3,2.7,3.3,2.7-1.5,2.7-3.3-1.2-3.3-2.7-3.3h0ZM7.3,10.8c-1.5,0-2.7-1.5-2.7-3.3s1.2-3.3,2.7-3.3,2.7,1.5,2.7,3.3c0,1.8-1.2,3.3-2.7,3.3h0ZM7.3,4.1c-1.5,0-2.8,1.5-2.8,3.4s1.2,3.4,2.8,3.4,2.8-1.5,2.8-3.4c0-1.9-1.2-3.4-2.8-3.4h0ZM7.3,10.9c-1.5,0-2.8-1.5-2.8-3.4s1.2-3.4,2.8-3.4,2.8,1.5,2.8,3.4-1.2,3.4-2.8,3.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.2 11.2 7.5 11.2 7.5 3.8 7.2 3.8 7.2 11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,3.7h0v7.5h0V3.7h0ZM7.4,3.7h0v7.5h0V3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.2,3.7h0s0,7.5,0,7.5h0V3.7h0ZM7.2,11.3h0V3.7s0,0,0,0v7.6s0,0,0,0c0,0,0,0,0,0h0ZM7.5,3.7h0s0,7.5,0,7.5h0s0-7.5,0-7.5h0ZM7.5,11.3h0V3.7s0,0,0,0v7.6s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,7.3c.4-.4,1.8-.7,3-.7,1.2,0,2.7.3,3,.7v.3c-.3-.3-1.4-.7-3-.7-1.6,0-2.8.4-3,.7v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.3,7.6v-.3s0,0,0,0v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.4,7.6v-.3s0,0,0,0v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,6.6c.7,0,1.4,0,2,.2.6.1,1,.3,1.1.5h0c-.2-.1-.7-.3-1.1-.4-.5-.1-1.2-.2-1.9-.2-.8,0-1.4,0-2,.2-.4,0-1,.3-1.1.5h0c0-.2.5-.5,1.1-.6.5-.1,1.2-.2,2-.2h0ZM7.3,6.9c.7,0,1.4,0,2,.2.6.1,1,.3,1.1.5h0c-.2-.1-.7-.3-1.1-.4-.5-.1-1.2-.2-1.9-.2-.8,0-1.5,0-2,.2-.4.1-1,.3-1.1.5h0c0-.2.5-.5,1.1-.6.5-.1,1.2-.2,2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,6.7c.7,0,1.4,0,2,.2.3,0,.9.3,1.1.5h0c-.1-.3-.5-.4-1.1-.6-.6-.1-1.3-.2-1.9-.2s-1.4,0-2,.2c-.6.1-1,.4-1.1.5h0c.1-.1.7-.3,1.1-.4.6-.1,1.3-.2,2-.2h0s0,0,0,0ZM4.3,7.4h0s0,0,0,0h0c0-.3.5-.5,1.1-.6.6-.1,1.3-.2,2-.2.7,0,1.4,0,2,.2.6.1,1,.3,1.1.5h0c-.2-.1-.8-.3-1.1-.4-.6-.1-1.3-.2-1.9-.2-.7,0-1.4,0-2,.2-.5.1-1,.3-1.1.5,0,0,0,0,0,0h0ZM7.3,7c.7,0,1.4,0,1.9.2.3,0,.9.3,1.1.5h0c-.1-.3-.5-.4-1.1-.6-.6-.1-1.3-.2-1.9-.2-.7,0-1.4,0-2,.2-.6.2-1,.4-1.1.5h0c.1-.2.7-.3,1.1-.4.6-.1,1.3-.2,2-.2h0ZM4.3,7.8s0,0,0,0c0,0,0,0,0,0h0c0-.3.5-.5,1.1-.6.6-.1,1.3-.2,2-.2.7,0,1.4,0,2,.2.6.1,1,.3,1.1.5h0c-.2-.1-.8-.3-1.1-.4-.6-.1-1.3-.2-1.9-.2-.7,0-1.4,0-2,.2-.5.1-1,.3-1.1.5,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,5c1.1,0,2.1.2,2.6.5l.2.3c-.4-.3-1.5-.5-2.7-.5-1,0-2.1.1-2.7.5l.2-.4c.5-.3,1.5-.4,2.5-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,5c.6,0,1.2,0,1.7.1.4,0,.7.2.9.4h0c-.1,0-.6-.2-1-.3-.5,0-1.1-.1-1.7-.1-.6,0-1.2,0-1.7.2-.4.1-.7.2-.8.3h0c.2-.2.4-.3.8-.4.5-.1,1.1-.2,1.7-.2h0ZM7.3,5.3c.6,0,1.3,0,1.8.2.5.1.9.3,1,.3h0c-.2,0-.5-.2-1-.3-.5-.1-1.1-.1-1.8-.1-.7,0-1.3,0-1.8.1-.5.1-.9.3-1,.4h0c.2-.2.4-.3.9-.4.5-.1,1.1-.1,1.8-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,5c.7,0,1.2,0,1.7.1.3,0,.8.2.9.4h0c-.1-.2-.5-.3-.9-.4-.4,0-1-.1-1.6-.1h0c-.7,0-1.3,0-1.7.2-.3,0-.6.2-.8.3h0c.1,0,.4-.1.8-.2.4,0,1-.2,1.7-.2h0ZM10,5.6s0,0,0,0c-.1-.2-.6-.3-1-.4-.4,0-1-.1-1.7-.1-.7,0-1.3,0-1.7.2-.4,0-.7.2-.8.3h0c.2-.2.4-.3.8-.4.4,0,1-.2,1.7-.2h0c.7,0,1.2,0,1.6.1.4,0,.8.2.9.4h0c0,.1,0,.2,0,.2,0,0,0,0,0,0h0ZM7.4,5.3h0c-.8,0-1.3,0-1.8.1-.4,0-.7.2-.9.3h0c0,0,.4-.2.9-.3.5-.1,1-.1,1.7-.1h.1c.7,0,1.3,0,1.7.1.5.1.8.2,1,.4h0c0-.2-.5-.3-1-.4-.4,0-1-.2-1.7-.2h0ZM10.1,5.9s0,0,0,0c-.2-.1-.5-.3-1-.4-.4,0-1-.1-1.7-.1h0s0,0,0,0c-.7,0-1.2,0-1.7.1-.5.1-.9.3-1,.4h0c.2-.3.5-.4.9-.5.5-.1,1-.1,1.8-.2h0c.7,0,1.3,0,1.7.2.5.1.9.3,1,.4h0c0,.1,0,.1,0,.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,9c-.6-.1-1.1-.1-1.5-.1-1.9,0-2.5.5-2.6.6v-.3c.3-.4,1.4-.7,2.6-.6.6,0,1.2,0,1.6.2v.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,8.5c.5,0,1.1,0,1.6.2h0c-.5,0-1,0-1.6,0-.7,0-1.4,0-2.1.3-.2,0-.6.2-.6.4h0c0-.2.3-.4.6-.5.7-.2,1.4-.3,2.1-.3h0ZM7.3,8.9c.5,0,1,0,1.5.1h0c-.5,0-1,0-1.5,0-.7,0-1.4,0-2,.3-.2,0-.5.2-.5.3h0c0-.1.2-.3.6-.4.7-.2,1.4-.3,2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.4,8.6c-.9,0-1.5,0-2.1.3-.4.1-.6.3-.6.4h0c0-.1.5-.3.6-.3.6-.2,1.2-.3,2.1-.3.6,0,1.1,0,1.6.2h0c-.5-.2-1.1-.2-1.6-.2h0ZM4.7,9.3s0,0,0,0h0c0-.2.5-.4.6-.5.6-.2,1.3-.3,2.1-.3.5,0,1.1,0,1.6.2h0c-.5,0-1,0-1.6,0-.9,0-1.5,0-2.1.3-.3,0-.6.3-.6.4,0,0,0,0,0,0h0ZM7.3,8.9c-.7,0-1.4,0-2,.3-.4.1-.5.3-.6.3h0c0,0,.4-.2.5-.3.5-.2,1.2-.3,1.9-.3h.1c.5,0,1,0,1.4.1h0c-.5-.2-1-.2-1.5-.2h0ZM4.8,9.6s0,0,0,0h0c0-.2.2-.3.6-.4.7-.2,1.3-.3,2-.3.5,0,1,0,1.5.1h0c-.4,0-.9,0-1.4,0h-.1c-.7,0-1.4,0-1.9.3-.2,0-.5.2-.5.3,0,0,0,0,0,0t0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.1,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.1,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0c0,0,0,0,0,0h0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.1,8.7h0s0,0,0,0h0s0,0,0,0h0ZM8,8.8s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0ZM8,8.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8,8.8h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7.9,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.9,8.8h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0ZM7.9,8.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.9,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM7.8,8.8s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0ZM7.8,8.8s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7.8,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0ZM7.8,8.8h0s0,0,0,0h0c0,0,0,0,0,0h0ZM7.8,8.7h0s0,0,0,0h0s0,0,0,0h0ZM7.7,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.8,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.7,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.7,8.8h0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0ZM7.6,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.6,8.7h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.6,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.6,8.8h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7.5,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.5,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.5,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.5,8.8h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h0ZM7.5,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0ZM7.5,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0ZM7.4,8.8h0s0,0,0,0h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7.4,8.8h0s0,0,0,0h0s0,0,0,0h0ZM7.4,8.7h0s0,0,0,0h0s0,0,0,0h0ZM7.3,8.8h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7.3,8.8h0s0,0,0,0h0s0,0,0,0h0ZM7.3,8.7h0s0,0,0,0h0s0,0,0,0h0ZM7.3,8.8h0c0,0,0,0,0,0h0c0,0,0,0,0,0h0ZM7.2,8.7h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.3,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.2,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.2,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM7.2,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0,0s0,0,0,0h0ZM7.1,8.8h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0ZM7.1,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0ZM7.1,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM7,8.8h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM7,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM7,8.8h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM6.9,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM6.9,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM6.9,8.8h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0t0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0ZM6.8,8.8s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM6.8,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,8.9s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.7,8.9s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.6,8.9h0s0,0,0,0h0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0ZM8.6,8.9s0,0,0,0,0,0,0,0c0,0,0,0,0,0t0,0h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0ZM8.6,8.9s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0ZM8.6,8.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0ZM8.5,8.9h0s0,0,0,0h0,0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.5,8.9h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0ZM8.5,8.9h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.4,8.8h0c0,0,0,0,0,0h0c0,0,0,0,0,0h0ZM8.4,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.4,8.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.4,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.3,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.3,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.2,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.2,8.8h0s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h0ZM8.2,8.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.2,8.8s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0ZM8.2,8.8h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.1,8.8h0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.8,9.1s0,0,0,0c0,0,0,0,0,0l.2-.4s0,0,0,0c0,0,0,0,0,0l-.2.4s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,5.4c.9,0,5.2,3.2,5.2,3.8l-.3.5c-.1-.7-4.5-3.8-5.2-3.8l.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.8,9.7l.2-.4s0,0,0,0c0,0,0,0,0,0l-.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.6,5.9l.2-.5s0,0,0,0c0,0,0,0,0,0l-.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,9.3c.1-.3-1.1-1.4-2.5-2.4-1.5-1-2.6-1.6-2.8-1.5h0c0,.1,0,0,0,0,0,0,0,0,.1,0,.3,0,1.3.6,2.7,1.5.6.4,2.5,1.9,2.5,2.4,0,0,0,0,0,0h0ZM4.5,5.9c.2-.1,1.4.6,2.8,1.5,1.3,1,2.6,2.1,2.5,2.3h0c0,0,0,0,0,0,0,0,0,0,0-.1,0-.2-1-1.1-2.4-2.2-1.5-1.1-2.7-1.7-2.8-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10,9.4s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0-.4-1.9-2-2.5-2.4-1.4-.9-2.3-1.5-2.7-1.5,0,0,0,0-.1,0h0c0,0,0,0,.1,0,.3,0,1.3.6,2.7,1.5.4.3,2.5,1.9,2.5,2.4h0s0,0,0,0c.1-.2-1-1.3-2.5-2.4-1.6-1.1-2.6-1.6-2.8-1.5h0c0,0,0,0,0,0h0c0-.1,0-.1.1-.1.4,0,1.7.8,2.7,1.5,1.3,1,2.7,2.1,2.5,2.4h0c0,0,0,0,0,0h0ZM4.6,6c.3,0,1.5.7,2.7,1.6,1.5,1.1,2.4,2,2.4,2.2,0,0,0,0,0,0h0c0,0,0,0,0,0,0-.3-1.3-1.4-2.5-2.2-1.2-.9-2.4-1.5-2.7-1.5s0,0,0,0h0s0,0,0,0h0ZM9.7,9.9h0s0,0,0,0c0,0,0,0,0,0,0-.2-1-1.1-2.4-2.2-1.2-.9-2.4-1.5-2.7-1.5s0,0,0,0h0s0,0,0,0h0c0,0,0-.1,0-.1.3,0,1.5.7,2.7,1.6,1.2.9,2.4,1.9,2.5,2.3,0,0,0,0,0,0h0c0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.5,7.9c0,.6.2,1.2.5,1.6.3.4.8.7,1.3.7s1-.2,1.3-.7c.3-.4.5-1,.5-1.6h0v-3h-3.6s0,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.1,4.9h-3.6s0,3,0,3c0,.6.2,1.1.5,1.6.3.4.8.7,1.3.7s.9-.2,1.3-.6c.3-.4.5-1,.5-1.6v-3h0ZM7.3,10.1c-.5,0-.9-.2-1.3-.7-.3-.4-.5-1-.5-1.6v-3h3.6s0,3,0,3c0,.6-.2,1.2-.5,1.6-.3.4-.8.7-1.3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.4,5.9v2c0,0,0,.1,0,.2,0,.3-.1.5-.3.7-.2.2-.4.4-.7.4s-.5-.1-.7-.4c-.2-.2-.3-.6-.3-.9v-2h2.1ZM5.6,7.9h0c0,.6.2,1.1.5,1.5.3.4.8.6,1.2.6s.9-.2,1.2-.6c.3-.4.5-.9.5-1.5h0v-2.9h-3.5v2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.3,5.9v2c0,.3.1.7.3.9.2.2.5.4.7.4s.5-.1.7-.4c.2-.2.3-.5.3-.7,0,0,0-.1,0-.2v-2h-2.1ZM7.3,9.2c-.3,0-.5-.1-.7-.4-.2-.2-.3-.6-.3-.9v-2h2.1s0,1.8,0,1.8v.2s0,.1,0,.2c0,.3-.1.5-.3.7-.2.2-.5.4-.7.4h0ZM9.1,5h-3.5s0,2.9,0,2.9c0,.6.2,1.1.5,1.5.3.4.8.6,1.2.6s.9-.2,1.2-.6c.3-.4.5-.9.5-1.5v-2.9h0ZM7.3,10.1c-.5,0-.9-.2-1.2-.6-.3-.4-.5-.9-.5-1.5v-2.9s3.5,0,3.5,0v2.9c0,.6-.2,1.1-.5,1.5-.3.4-.8.6-1.2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,7.6h0c0,0,0,.2,0,.2,0,0,.1,0,.2,0s.1,0,.2,0c0,0,0-.1,0-.2v-.4h-.5v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,7.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.4,7.4s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,7.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,7.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,7.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,8.6h0c0,0,0,.2,0,.2,0,0,0,0,.2,0s.1,0,.2,0c0,0,0-.1,0-.2v-.4h-.5v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,8.3s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.3,8.4s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,8.6s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,8.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,8.3s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,7.6h0c0,0,0,.2,0,.2s0,0,.2,0,.1,0,.2,0c0,0,0-.1,0-.2v-.4h-.5v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.8,7.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.7,7.4s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.8,7.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,7.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,7.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,7.6h0c0,0,0,.2,0,.2,0,0,0,0,.2,0s.1,0,.2,0c0,0,0-.1,0-.2v-.4h-.5v.4s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.1,7.3s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,7.4s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.1,7.6s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,7.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,7.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,6.6h0c0,0,0,.2,0,.2s0,0,.2,0,.1,0,.2,0c0,0,0-.1,0-.2v-.4h-.5v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,6.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.4,6.5s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,6.6s0,0,0,0,0,0,0,0,0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,6.6s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.2,6.3s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.8,5.8c0-.2.1-.3.1-.3s.1,0,.1.3h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,5.5v.2s.1,0,.1,0c0-.2.1-.2.1-.2,0,0,.1,0,.1.2h.1v-.2s-.5,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,5.5s.1,0,.1.2h.1s0-.2,0-.2h-.2ZM5.9,5.5h-.2s0,.2,0,.2h.1c0-.2,0-.2.1-.2h0ZM6.2,5.8h-.1c0-.2-.1-.2-.1-.2,0,0-.1,0-.1.2h-.1s0-.2,0-.2h.5s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,5.8h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,5.8h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,5.8h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,5.8c0-.1,0-.2,0-.2,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,5.6s0,0,0,.2h.1c0-.1,0-.1,0-.2h0ZM6,5.8h-.1c0-.1,0-.2,0-.2,0,0,0,0,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,5.4h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,5.5h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,5.5h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,5.6h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,5.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,5.1h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6,5.2h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6 5.2 6 5.4 5.9 5.4 5.9 5.2 6 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,5.2h-.1s0,.2,0,.2h.1s0-.2,0-.2h0ZM6,5.4h-.1v-.3h.1s0,.3,0,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6.2,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.2 5.3 6.2 5.4 6 5.4 6 5.3 6.2 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM6.2,5.4h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM5.9,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.8 5.3 5.8 5.4 5.7 5.4 5.7 5.3 5.8 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.8,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM5.9,5.4h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,5.3s0,0,0,0h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.8,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,5.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,5.1h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM7.4,5.2h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.4 5.2 7.4 5.4 7.3 5.4 7.3 5.2 7.4 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.4,5.2h-.1s0,.2,0,.2h.1s0-.2,0-.2h0ZM7.4,5.4h-.1v-.3s.1,0,.1,0v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.5,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM7.6,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.6 5.3 7.6 5.4 7.4 5.4 7.4 5.3 7.6 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.6,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM7.4,5.4h0c0-.1.1-.1.1-.1h0c0,.1-.1.1-.1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.1,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM7.2,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.2 5.3 7.2 5.4 7.1 5.4 7.1 5.3 7.2 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.2,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM7.3,5.4h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,5.8c0-.2.1-.3.1-.3,0,0,.1,0,.1.3h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,5.5v.2s.1,0,.1,0c0-.2.1-.2.1-.2,0,0,.1,0,.1.2h.1v-.2s-.5,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.4,5.5s.1,0,.1.2h.1s0-.2,0-.2h-.2ZM7.3,5.5h-.2s0,.2,0,.2h.1c0-.2,0-.2.1-.2h0ZM7.6,5.8h-.1c0-.2-.1-.2-.1-.2,0,0-.1,0-.1.2h-.1s0-.2,0-.2h.5s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,5.8h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.1,5.8h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM7.6,5.8h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,5.8c0-.1,0-.2,0-.2,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,5.6s0,0,0,.2h.1c0-.1,0-.1,0-.2h0ZM7.4,5.8h-.1c0-.1,0-.2,0-.2,0,0,0,0,0,.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,5.4h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.1,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM7.6,5.5h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,5.5h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.1,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM7.6,5.6h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,5.3s0,0,0,0h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.5,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.2,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,5.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,5.1h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.8,5.2h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.8 5.2 8.8 5.4 8.7 5.4 8.7 5.2 8.8 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.8,5.2h-.1s0,.2,0,.2h.1s0-.2,0-.2h0ZM8.8,5.5h-.1s0-.3,0-.3h.1s0,.3,0,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.8,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM9,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.9 5.3 9 5.4 8.8 5.4 8.8 5.3 8.9 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.9,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM9,5.5h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,5.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,5.2h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.6,5.3h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.6 5.3 8.6 5.4 8.5 5.4 8.5 5.3 8.6 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,5.3h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM8.6,5.5h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,5.8c0-.2.1-.3.1-.3,0,0,.1,0,.1.3h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,5.5v.2s.1,0,.1,0c0-.2.1-.2.1-.2s.1,0,.1.2h.1v-.2s-.5,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,5.5s.1,0,.1.2h.1s0-.2,0-.2h-.2ZM8.7,5.5h-.2s0,.2,0,.2h.1c0-.2,0-.2.1-.2h0ZM9,5.8h-.1c0-.2-.1-.2-.1-.2,0,0-.1,0-.1.2h-.1s0-.2,0-.2h.5s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,5.8h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,5.8h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,5.8h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,5.8c0-.1,0-.2,0-.2,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,5.6s0,0,0,.2h.1c0-.1,0-.1,0-.2h0ZM8.8,5.8h-.1c0-.1,0-.2,0-.2,0,0,0,0,0,.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,5.4h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,5.5h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,5.5h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,5.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,5.6h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,5.3s0,0,0,0h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.9,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,5.4s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,6.8h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,6.8h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6,6.9h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6 6.9 6 7.2 5.9 7.2 5.9 6.9 6 6.9 6 6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,6.9h-.1s0,.2,0,.2h.1s0-.2,0-.2h0ZM6,7.2h-.1s0-.3,0-.3h.1s0,.3,0,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,7h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,7h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6.2,7.1h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.2 7 6.2 7.2 6 7.2 6 7 6.2 7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,7h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM6.2,7.2h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,7h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,7h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM5.9,7.1h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.8 7 5.8 7.2 5.7 7.2 5.7 7 5.8 7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.8,7h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM5.9,7.2h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.8,7.5c0-.2.1-.3.1-.3,0,0,.1,0,.1.3h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,7.3v.2s.1,0,.1,0c0-.2.1-.2.1-.2s.1,0,.1.2h.1v-.2s-.5,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,7.3s.1,0,.1.2h.1s0-.2,0-.2h-.2ZM5.9,7.3h-.2s0,.2,0,.2h.1c0-.2,0-.2.1-.2h0ZM6.2,7.5h-.1c0-.2-.1-.2-.1-.2,0,0-.1,0-.1.2h-.1s0-.2,0-.2h.5s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,7.5h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,7.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,7.6h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,7.5c0-.1,0-.2,0-.2,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,7.4s0,0,0,.2h.1c0-.1,0-.1,0-.2h0ZM6,7.5h-.1c0-.1,0-.2,0-.2,0,0,0,0,0,.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,7.2h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,7.2h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,7.2h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,7.2h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.7,7.2h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM6.2,7.3h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.9,7s0,0,0,0h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,7.1s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.8,7.1s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,8.7h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,8.7h0c0,0,.1.2.1.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.6,8.9h0s0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.6 8.9 8.5 9 8.4 8.9 8.5 8.8 8.6 8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,8.8v.2c-.1,0,0,0,0,0v-.2c.1,0,0,0,0,0h0ZM8.5,9h0c0-.1.1-.3.1-.3h0c0,0-.1.3-.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,8.9h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,8.9h0c0,0,0,.2,0,.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.7,9.1h0s0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.7 9.1 8.6 9.2 8.5 9.1 8.6 9 8.7 9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,9h0c0,0,0,.2,0,.2h0c0,0,0-.2,0-.2h0ZM8.6,9.2h0c0-.1,0-.2,0-.2h0c0,.1,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.4,8.6h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.4,8.6h0c0,0,0,.2,0,.2h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.4,8.8h0s0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.4 8.8 8.4 8.9 8.3 8.8 8.3 8.7 8.4 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.3,8.7h0c0,0,0,.2,0,.2h0c0,0,0-.2,0-.2h0ZM8.4,8.9h0c0-.1,0-.2,0-.2h0c0,.1,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.1,9.1c.1-.1.2,0,.2,0,0,0,0,.1,0,.3l-.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,8.9l-.2.2h0c.1,0,.2,0,.2,0,0,0,0,.1,0,.3h0c0,.1.1,0,.1,0l-.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.2,8.9v.2c-.1,0,0,0,0,0,0,0,.2,0,.2,0l-.2-.2h0ZM8.4,9.1s0,0,0,0c0,0,0,.1,0,.2h0c0,0,.1,0,.1,0l-.2-.2h0ZM8.4,9.5h0c.1-.3,0-.4,0-.4h0s0,0,0,0,0,0-.1,0h0c0-.1.2-.3.2-.3l.3.4v.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,9l.4.5s0,0,0,0c0,0,0,0,0,0l-.4-.4s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8,9l.4.5h0s-.4-.5-.4-.5h0s0,0,0,0h0ZM8.4,9.5h0s-.4-.5-.4-.5c0,0,0,0,0,0h0s.4.4.4.4c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,9.2c0,0,.1,0,.1,0,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.3,9.1s0,0,0,0h0c0,0,0,0,0,0,0,0,0,0,0,0h0ZM8.3,9.3h-.1c0-.2.1-.2.1-.2,0,0,0,0,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,8.8l.4.4s0,0,0,0c0,0,0,0,0,0l-.4-.4s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.2,8.8h0s.4.5.4.5h0s-.4-.5-.4-.5h0ZM8.6,9.3h0s-.4-.4-.4-.4c0,0,0,0,0,0h0s.4.4.4.4c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,8.8l.3.4s0,0,0,0c0,0,0,0,0,0l-.3-.4s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.2,8.8h0s.3.4.3.4h0s-.3-.4-.3-.4h0ZM8.5,9.3h0s-.3-.4-.3-.4c0,0,0,0,0,0h0s.3.4.3.4c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,8.8s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,9s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.3,8.8s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,6.8h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,6.8h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.8,6.9h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.8 6.9 8.8 7.2 8.7 7.2 8.7 6.9 8.8 6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.8,6.9h-.1v.2h.1s0-.2,0-.2h0ZM8.8,7.2h-.1v-.3h.1s0,.3,0,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,7h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.8,7h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM9,7.1h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.9 7 9 7.2 8.8 7.2 8.8 7 8.9 7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.9,7h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM9,7.2h-.1c0-.1.1-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,7h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,0,0,0h-.1s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,7h0s0,0,0,0h.1s0,0,0,0h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM8.6,7.1h-.2c0-.1,0-.1,0-.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c0,0,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.6 7 8.6 7.2 8.5 7.2 8.5 7 8.6 7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,7h-.1s0,.1,0,.1h.1s0-.1,0-.1h0ZM8.5,7.2h0c0-.1.1-.1.1-.1h0c0,.1-.1.1-.1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,7.5c0-.2.1-.3.1-.3,0,0,.1,0,.1.3h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,7.3v.2s.1,0,.1,0c0-.2.1-.2.1-.2s.1,0,.1.2h.1v-.2s-.5,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,7.3s.1,0,.1.2h.1s0-.2,0-.2h-.2ZM8.7,7.3h-.2s0,.2,0,.2h.1c0-.2,0-.2.1-.2h0ZM9,7.5h-.1c0-.2-.1-.2-.1-.2,0,0-.1,0-.1.2h-.1s0-.2,0-.2h.5s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,7.5h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,7.5h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,7.6h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,7.5c0-.1,0-.2,0-.2,0,0,0,0,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,7.4s0,0,0,.2h.1c0-.1,0-.1,0-.2h0ZM8.8,7.5h-.1c0-.1,0-.2,0-.2,0,0,0,0,0,.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,7.2h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,7.2h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,7.2h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,7.2h.5s0,0,0,0,0,0,0,0h-.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,7.2h0s.5,0,.5,0c0,0,0,0,0,0h-.5ZM9,7.3h-.5s0,0,0,0,0,0,0,0h.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.7,7s0,0,0,0h0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.9,7.1s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.5,7.1s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,8.8h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0,.1,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,8.8h0s0,0,0,0h0s0-.1,0-.1h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6.1,8.9h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s-.1.2-.1.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.2 8.8 6.3 8.9 6.2 9 6.1 8.9 6.2 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,8.8h0c0,0,.1.3.1.3h0c0-.1-.1-.3-.1-.3h0ZM6.2,9v-.2c-.1,0,0-.1,0-.1l.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.2,8.8h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0,.1,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,8.7h0s0,0,0,0h0s0-.1,0-.1h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6.2,8.8h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s-.1.2-.1.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.3 8.7 6.4 8.8 6.3 8.9 6.3 8.8 6.3 8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.3,8.7h0c0,.1,0,.2,0,.2h0c0-.1,0-.2,0-.2h0ZM6.3,8.9h0c0-.1,0-.2,0-.2h0c0,0,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,9h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0h0c0,.1,0,.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,9h0s0,0,0,0h0s0-.1,0-.1h0c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0ZM6,9.1h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s-.1.2-.1.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.1 9 6.2 9.1 6.1 9.2 6 9.1 6.1 9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,9h0c0,.1,0,.2,0,.2h0c0-.1,0-.2,0-.2h0ZM6.1,9.2h0c0-.1,0-.2,0-.2h0c0,0,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,9.3c-.1-.2,0-.3,0-.3,0,0,.1,0,.2,0l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.2,9.2v.2c.1,0,.2-.1.2-.1-.1-.1,0-.3,0-.3s.1,0,.2,0h0c0-.1-.2-.3-.2-.3l-.3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.4,9c0,0,.1,0,.1,0h0c0-.1-.2-.2-.2-.2v.2c-.1,0-.1,0,0,0h0ZM6.3,9.1v.2c-.1,0,0,.2,0,.2h0c0-.2,0-.2,0-.3,0,0,0,0,0,0h0ZM6.3,9.4v-.2c-.1,0,.2-.4.2-.4h.2c0,.1,0,.3,0,.3,0,0,0,0-.1,0s0,0,0,0h0s0,.1,0,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,9.4l.4-.4s0,0,0,0c0,0,0,0,0,0l-.4.5s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.6,9l-.4.5h0s0,0,0,0h0s.4-.5.4-.5h0s0,0,0,0h0ZM6.3,9.5h0s0,0,0,0l.4-.4s0,0,0,0c0,0,0,0,0,0l-.4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,9.3c0,0,0-.2,0-.2,0,0,0,0,.1,0h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.4,9.1s0,0,0,.2h0c0-.2-.1-.2-.1-.2h0ZM6.4,9.3h0c0,0,0-.2,0-.2,0,0,0,0,.2,0h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,9.2l.4-.4s0,0,0,0c0,0,0,0,0,0l-.4.4s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,9.2h0s0,0,0,0l.4-.4h0s0,0,0,0l-.4.4h0s0,0,0,0h0ZM6.1,9.2h0s0,0,0,0l.4-.4h0s0,0,0,0l-.4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,9.2l.3-.4s0,0,0,0c0,0,0,0,0,0l-.3.4s0,0,0,0c0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,9.3h0s0,0,0,0l.3-.4h0s0,0,0,0l-.3.4h0s0,0,0,0h0ZM6.1,9.3h0s0,0,0,0l.3-.4h0s0,0,0,0l-.4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,8.9s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.3,8.8s0,0,0,0h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,9.1s0,0,0,0h0s0,0,0,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.7e6ce2918c503de9c23ccc0c88625c55.svg";
export { ForwardRef as ReactComponent };